import React from 'react';
import { useTranslation } from 'react-i18next';
import { HostMediaImageResolutions } from 'types/listingV3';
import { HostedBy, Hosts } from 'types/hosts';
import { Name, HostPhoto, InfoBox } from './styles';

export interface HostInfoBoxProps {
  firstName?: string | null;
  profilePicture?: HostedBy['profilePicture'] | Hosts['profilePicture'];
}

export const HostInfoBox = ({
  firstName,
  profilePicture,
}: HostInfoBoxProps) => {
  const { t } = useTranslation();

  if (firstName === 'No Host' || !firstName) return null;

  const profilePictureUrl =
    profilePicture && HostMediaImageResolutions['360w'] in profilePicture.uri
      ? profilePicture?.uri[HostMediaImageResolutions['360w']]
      : profilePicture?.uri[HostMediaImageResolutions.original];

  return (
    <InfoBox className="listing-carousel-card-details">
      {profilePictureUrl && (
        <HostPhoto
          src={profilePictureUrl}
          alt={t('profileImageOfHost', { hostName: firstName })}
          className="listing-card-host-photo"
        />
      )}
      <Name>
        {t('hostedBy')} {firstName}
      </Name>
    </InfoBox>
  );
};
